import React from 'react'

export default function ArrowDownIcon({ ...props }) {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.279593 6.41907C0.696991 5.91589 1.4301 5.8576 1.91707 6.28891L12 15.2195L22.0829 6.28891C22.5699 5.85762 23.303 5.91589 23.7205 6.41907C24.1378 6.92227 24.0814 7.67982 23.5944 8.11113L12.7557 17.7112C12.3208 18.0963 11.6792 18.0963 11.2442 17.7112L0.405554 8.11113C-0.0813978 7.67982 -0.137805 6.92225 0.279593 6.41907Z" fill="currentcolor" />
        </svg>
    )
}